// extracted by mini-css-extract-plugin
export var active = "_bu-7";
export var container = "_bu-0";
export var evenWidth = "_bu-4";
export var large = "_bu-5";
export var outlet = "_bu-8";
export var slide = "_bu-2";
export var small = "_bu-6";
export var tab = "_bu-3";
export var tabs = "_bu-1";